import { userRoles as ur } from "../data/userRole";
import CustomerData from '../components/CustomerData';
import CustomerDetail from '../components/CustomerAdmin/CustomerDetail';
import CustomerCreditLog from '../components/CustomerAdmin/CustomerCreditLog';

export const superAdmin_routes = [
    {
        path: "/admin/CustomerData",
        ele: <CustomerData />,
        availability: [ur.superAdmin]
    },
    {
        path: "/admin/CustomerDetail/:id",
        ele: <CustomerDetail />,
        availability: [ur.superAdmin, ur.admin, ur.frontdesk]
    },
    {
        path: "/admin/CustomerCreditLog/:id",
        ele: <CustomerCreditLog />,
        availability: [ur.superAdmin, ur.admin, ur.frontdesk]
    },
]